<!--Tarjeta de evento que se muestra en la lista de eventos para hacer checkIn-->
<template>
  <v-hover>
    <!-- TARJETA DE EVENTO -->
    <template v-slot:default="{ hover }">
      <v-card>
        <v-container fluid>
          <v-row justify="center">
            <v-col cols="12">
              <v-row justify="center">
                <v-col cols="12" sm="3" class="py-0">
                  <v-row justify="center" align="center" class="fill-height">
                    <v-avatar size="100">
                      <img v-if="event.eventImage != '' && event.eventImage != null" :src="event.eventImage"/>
                      <img v-else src="../../../assets/img/DefaultEvento.jpg" />
                    </v-avatar>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="9" class="py-0">
                  <v-row class="text-center">
                    <v-col cols="12" class="pb-0">
                      <h2 class="headline font-weight-bold">EVENTO</h2>
                      {{event.name}}
                    </v-col>
                    <v-col cols="6">
                      <h2 class="headline font-weight-bold">INICIO</h2>
                      {{ event.startDate }}
                    </v-col>
                    <v-col cols="6">
                      <v-row justify="center" align="center" class="fill-height pt-0 mt-0">
                        <v-chip v-if="event.estatus" color="secondary" text-color="white" class="mt-0">
                          <v-avatar class="mr-md-1">
                            <v-icon>check_circle</v-icon>
                          </v-avatar>
                          <span class="subtitle-2">Disponible</span>
                        </v-chip>
                        <v-chip v-else color="error" text-color="white" class="mt-0">
                          <v-avatar class="mr-md-1">
                            <v-icon>check_circle</v-icon>
                          </v-avatar>
                          <span class="subtitle-2">Finalizado</span>
                        </v-chip>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <v-fade-transition>
          <v-overlay v-if="hover" absolute color="#a5a5a5">
          </v-overlay>
        </v-fade-transition>
      </v-card>
    </template>
  </v-hover>
</template>
<script>
export default {
  props: {
    event: { type: Object, required: true }
  },
  data() {
    return {
      overlay: false
    };
  },
  computed: {
    getLargeSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size:3em";
        case "sm":
          return "font-size:3em";
        case "md":
          return "font-size:4em";
        case "lg":
          return "font-size:6em";
        case "xl":
          return "font-size:7.5em";
      }
    }
  },
  created() {
    console.log(this.event);
  }
};
</script>